/**
 * Lightweight non-throwing error logger.
 *
 * Used inside `.catch(swallow("context"))` in places where we intentionally
 * don't want the error to bubble to the UI but still want a signal in the
 * console for debugging. In production builds this stays as a plain
 * console.warn — cheap, safe, and never blocks the render path.
 */
export const swallow = (context = "unknown") => (err) => {
  // eslint-disable-next-line no-console
  console.warn(`[impo] silent failure @ ${context}:`, err?.message || err);
};
